// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { useParams, useNavigate } from "react-router-dom";
// import config from '../../config';
// import { Calendar } from 'primereact/calendar';
// import { Chips } from 'primereact/chips';

// function UpdateReviewDetail() {
//     const { id } = useParams(); // Get the project ID from the URL
//     const navigate = useNavigate();
//     const [review, setReview] = useState({
//         title: '',
//         description: '',
//         clientname: '',
//     });
//     const [featuredImage, setFeaturedImage] = useState(null);
//     const [removeImages, setRemoveImages] = useState([]);
//     const fileInputRef = useRef(null);
//     const [newImages, setNewImages] = useState([]);
//     const [error, setError] = useState('');
//     const [successMessage, setSuccessMessage] = useState('');
//     const featuredImageRef = useRef(null);

//     const [centerContent, setCenterContent] = useState([
//         { title: '', description: '', clientname:'' }
//     ]);

//     const handleContentChange = (index, event) => {
//         const newFields = centerContent.map((field, fieldIndex) => {
//             if (index === fieldIndex) {
//                 return { ...field, [event.target.name]: event.target.value };
//             }
//             return field;
//         });
//         setCenterContent(newFields);
//     };

//     // const addContentFields = () => {
//     //     setCenterContent([...centerContent, { title: '', description: '' }]);
//     // };

//     // const removeContentFields = (index) => {
//     //     const newFields = centerContent.filter((field, fieldIndex) => index !== fieldIndex);
//     //     setCenterContent(newFields);
//     // };

//     useEffect(() => {
//         const fetchBlogDetails = async () => {
//             try {
//                 const response = await axios.get(`${config.BASE_URL}/api/admin/get-review/${id}`, { withCredentials: true });
//                 setReview(response?.data);
//                 setCenterContent(response?.data?.centerContent);
//             } catch (err) {
//                 setError('Failed to fetch review details');
//             }
//         };

//         fetchBlogDetails();
//     }, [id]);

//     const handleRemoveImage = async (imageName) => {
//         try {
//             const response = await axios.post(`${config.BASE_URL}/api/admin/remove-image-review`, {
//                 reviewId: review._id,
//                 imageName
//             }, { withCredentials: true });

//             if (response.status === 200) {
//                 setRemoveImages(prev => [...prev, imageName]);

//                 setReview(prevReview => {
//                     return {
//                         ...prevReview,
//                         featuredImage: prevReview.featuredImage === imageName ? null : prevReview.featuredImage,
//                     };
//                 });
//             } else {
//                 console.error('Failed to remove image');
//             }
//         } catch (err) {
//             console.error('Error removing image:', err);
//         }
//     };

//     const handleFeaturedImageChange = (e) => {
//         setFeaturedImage(e.target.files[0]); // Set the featured image
//     };

//     const handleNewImageChange = (e) => {
//         setNewImages(e.target.files); // Set new images to be uploaded
//     };

//     const handleFormSubmit = async (e) => {
//         e.preventDefault();

//         const formData = new FormData();
//         formData.append('title', review.title);
//         formData.append('description', review.description);
//         formData.append('clientname', review.clientname);

//         if (featuredImage) {
//             formData.append('featuredImage', featuredImage);
//         }

//         try {
//             const response = await axios.put(`${config.BASE_URL}/api/admin/update-review/${id}`, formData, {
//                 headers: {
//                     'Content-Type': 'multipart/form-data',
//                 },
//                 withCredentials: true,
//             });

//             setReview(response.data.review);

//             if (featuredImageRef.current) {
//                 featuredImageRef.current.value = '';
//             }

//             setFeaturedImage(null);
//             setSuccessMessage('Review updated successfully!');
//         } catch (err) {
//             setError('Failed to update review');
//         }
//     }

//     return (
//         <div className="dashboard update_detail_wrap">
//             <div className="container">
//                 <h1 className="dash_title">Edit Review</h1>
//                 <div className="back_btn_wrap">
//                     <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
//                 </div>
//                 {review ? (
//                     <form onSubmit={handleFormSubmit} encType="multipart/form-data">
//                         <div className="update_details_wrap">
//                             <div className="form-group">
//                                 <label>Review Title</label>
//                                 <input
//                                     type="text"
//                                     value={review.title}
//                                     onChange={(e) => setReview({ ...review, title: e.target.value })}
//                                 />
//                             </div>

//                             <div className="form-group textareaField">
//                                 <h2>Description</h2>
//                                 <textarea
//                                     name="description"
//                                     value={review.description}
//                                     onChange={(e) => setReview({ ...review, description: e.target.value })}
//                                     required
//                                 />
//                             </div>

//                             <div className="form-group">
//                                 <div className="detail_banner_wrap">
//                                     <div className="detail_img_grid">

//                                         <div className="upload_item">
//                                             <label>Featured Image</label>
//                                             <input type="file" onChange={handleFeaturedImageChange} ref={featuredImageRef} />
//                                         </div>
//                                         <div className="detail_img_grid">
//                                             {review.featuredImage ? (
//                                                 <div className="detail_img_item">
//                                                     <div className="banner_img_wrap">
//                                                         <img src={`${config.BASE_URL}${review.featuredImage}`} alt="Featured" />
//                                                     </div>
//                                                     <button className="remove_btn" type="button" onClick={() => handleRemoveImage(review.featuredImage)}>Remove</button>
//                                                 </div>
//                                             ) : (
//                                                 <p>No image available.</p>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="form-group titleField">
//                                 <h2>Client Name</h2>
//                                 <textarea
//                                     name="clientname"
//                                     value={review.clientname}
//                                     onChange={(e) => setReview({ ...review, clientname: e.target.value })}
//                                     required
//                                 />
//                             </div>

//                             <div className="update_btn_wrap">
//                                 <button className="update_btn" type="submit">Update Review</button>
//                             </div>
//                             {successMessage && <p className="success-message">{successMessage}</p>}
//                             {error && <p className="error-message">{error}</p>}
//                         </div>
//                     </form>
//                 ) : (
//                     <h5>Review not found!</h5>
//                 )}
//             </div>
//         </div>
//     );
// }

// export default UpdateReviewDetail;






import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import config from '../../config';

function UpdateReviewDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [activeLanguage, setActiveLanguage] = useState('en');
    
    // English content (main data)
    const [review, setReview] = useState({
        title: '',
        description: '',
        clientname: '',
        // slug: ''
    });
    
    // Spanish translation data
    const [spanishData, setSpanishData] = useState({
        language: 'es',
        title: '',
        description: '',
        clientname: ''
    });
    
    const [featuredImage, setFeaturedImage] = useState(null);
    const [currentFeaturedImage, setCurrentFeaturedImage] = useState('');
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const featuredImageRef = useRef(null);

    useEffect(() => {
        const fetchReviewDetails = async () => {
            try {
                const response = await axios.get(`${config.BASE_URL}/api/admin/get-review-admin/${id}`, { 
                    withCredentials: true 
                });
                
                const data = response?.data;
                
                // Set English (main) content
                setReview({
                    title: data.title || '',
                    description: data.description || '',
                    clientname: data.clientname || '',
                    // slug: data.slug || ''
                });
                
                // Set Spanish translation data
                setSpanishData({
                    language: 'es',
                    title: data.spanishData?.title || '',
                    description: data.spanishData?.description || '',
                    clientname: data.spanishData?.clientname || ''
                });
                
                // Set featured image
                setCurrentFeaturedImage(data.featuredImage || '');
                
            } catch (err) {
                setError('Failed to fetch review details');
                console.error('Error fetching review:', err);
            }
        };

        fetchReviewDetails();
    }, [id]);

    // Handle language tab switching
    const switchLanguage = (lang) => {
        setActiveLanguage(lang);
    };

    // Handle English form changes
    const handleEnglishChange = (e) => {
        const { name, value } = e.target;
        setReview(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Handle Spanish form changes
    const handleSpanishChange = (e) => {
        const { name, value } = e.target;
        setSpanishData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleRemoveImage = async (imageName) => {
        try {
            const response = await axios.post(`${config.BASE_URL}/api/admin/remove-image-review`, {
                reviewId: id,
                imageName
            }, { withCredentials: true });

            if (response.status === 200) {
                setCurrentFeaturedImage('');
                setSuccessMessage('Image removed successfully!');
                setTimeout(() => setSuccessMessage(''), 3000);
            } else {
                console.error('Failed to remove image');
            }
        } catch (err) {
            console.error('Error removing image:', err);
            setError('Failed to remove image');
        }
    };

    const handleFeaturedImageChange = (e) => {
        setFeaturedImage(e.target.files[0]);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccessMessage('');

        const formData = new FormData();
        
        // English content
        formData.append('title', review.title);
        formData.append('description', review.description);
        formData.append('clientname', review.clientname);
        // formData.append('slug', review.slug);
        
        // Spanish translation data
        formData.append('spanishData', JSON.stringify(spanishData));

        // Featured image (if new one selected)
        if (featuredImage) {
            formData.append('featuredImage', featuredImage);
        }

        try {
            const response = await axios.put(`${config.BASE_URL}/api/admin/update-review/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                withCredentials: true,
            });

            // Update local state with response data
            const updatedData = response.data.review;
            setReview({
                title: updatedData.title,
                description: updatedData.description,
                clientname: updatedData.clientname,
                // slug: updatedData.slug
            });
            
            setSpanishData({
                language: 'es',
                title: updatedData.spanishData?.title || '',
                description: updatedData.spanishData?.description || '',
                clientname: updatedData.spanishData?.clientname || ''
            });

            if (updatedData.featuredImage) {
                setCurrentFeaturedImage(updatedData.featuredImage);
            }

            // Reset file input
            if (featuredImageRef.current) {
                featuredImageRef.current.value = '';
            }
            setFeaturedImage(null);
            
            setSuccessMessage('Review updated successfully!');
            setTimeout(() => setSuccessMessage(''), 5000);
            
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to update review');
            console.error('Error updating review:', err);
        }
    };

    return (
        <div className="dashboard update_detail_wrap">
            <div className="container">
                <h1 className="dash_title">Edit Review</h1>
                <div className="back_btn_wrap">
                    <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
                </div>
                
                {/* Language Tabs */}
                <div className="language-tabs" style={{ marginBottom: '20px' }}>
                    <button 
                        type="button" 
                        className={`tab-btn ${activeLanguage === 'en' ? 'active' : ''}`}
                        onClick={() => switchLanguage('en')}
                        style={{
                            padding: '10px 20px',
                            marginRight: '10px',
                            backgroundColor: activeLanguage === 'en' ? '#007bff' : '#f8f9fa',
                            color: activeLanguage === 'en' ? 'white' : 'black',
                            border: '1px solid #ddd',
                            cursor: 'pointer'
                        }}
                    >
                        English
                    </button>
                    <button 
                        type="button" 
                        className={`tab-btn ${activeLanguage === 'es' ? 'active' : ''}`}
                        onClick={() => switchLanguage('es')}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: activeLanguage === 'es' ? '#007bff' : '#f8f9fa',
                            color: activeLanguage === 'es' ? 'white' : 'black',
                            border: '1px solid #ddd',
                            cursor: 'pointer'
                        }}
                    >
                        Spanish
                    </button>
                </div>

                <form onSubmit={handleFormSubmit} encType="multipart/form-data">
                    <div className="update_details_wrap">
                        
                        {/* English Content */}
                        {activeLanguage === 'en' && (
                            <div className="language-content">
                                <h3>English Content</h3>
                                
                                <div className="form-group">
                                    <label>Title (English)</label>
                                    <input
                                        type="text"
                                        name="title"
                                        value={review.title}
                                        onChange={handleEnglishChange}
                                        required
                                    />
                                </div>

                                {/* <div className="form-group">
                                    <label>Slug (English)</label>
                                    <input
                                        type="text"
                                        name="slug"
                                        value={review.slug}
                                        onChange={handleEnglishChange}
                                        placeholder="url-friendly-slug"
                                        required
                                    />
                                </div> */}

                                <div className="form-group textareaField">
                                    <label>Description (English)</label>
                                    <textarea
                                        name="description"
                                        value={review.description}
                                        onChange={handleEnglishChange}
                                        rows="4"
                                        placeholder="Enter review description"
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Client Name (English)</label>
                                    <input
                                        type="text"
                                        name="clientname"
                                        value={review.clientname}
                                        onChange={handleEnglishChange}
                                        placeholder="Enter client name"
                                        required
                                    />
                                </div>
                            </div>
                        )}

                        {/* Spanish Content */}
                        {activeLanguage === 'es' && (
                            <div className="language-content">
                                <h3>Spanish Content</h3>
                                
                                <div className="form-group">
                                    <label>Title (Spanish)</label>
                                    <input
                                        type="text"
                                        name="title"
                                        value={spanishData.title}
                                        onChange={handleSpanishChange}
                                        placeholder="Título en español"
                                    />
                                </div>

                                <div className="form-group textareaField">
                                    <label>Description (Spanish)</label>
                                    <textarea
                                        name="description"
                                        value={spanishData.description}
                                        onChange={handleSpanishChange}
                                        rows="4"
                                        placeholder="Ingrese la descripción de la reseña"
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Client Name (Spanish)</label>
                                    <input
                                        type="text"
                                        name="clientname"
                                        value={spanishData.clientname}
                                        onChange={handleSpanishChange}
                                        placeholder="Ingrese el nombre del cliente"
                                    />
                                </div>
                            </div>
                        )}

                        {/* Featured Image Section - Always Visible */}
                        <div className="form-group">
                            <div className="detail_banner_wrap">
                                <div className="detail_img_grid">
                                    <div className="upload_item">
                                        <label>Featured Image</label>
                                        <input 
                                            type="file" 
                                            onChange={handleFeaturedImageChange} 
                                            ref={featuredImageRef}
                                            accept="image/*"
                                        />
                                        <small style={{ color: '#666', fontSize: '12px', display: 'block', marginTop: '5px' }}>
                                            This image will be shared across all language versions
                                        </small>
                                    </div>
                                    
                                    <div className="detail_img_grid">
                                        {currentFeaturedImage ? (
                                            <div className="detail_img_item">
                                                <div className="banner_img_wrap">
                                                    <img 
                                                        src={`${config.BASE_URL}${currentFeaturedImage}`} 
                                                        alt="Featured" 
                                                        style={{ maxWidth: '200px', height: 'auto' }}
                                                    />
                                                </div>
                                                <button 
                                                    className="remove_btn" 
                                                    type="button" 
                                                    onClick={() => handleRemoveImage(currentFeaturedImage)}
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        ) : (
                                            <p>No image available.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="update_btn_wrap">
                            <button className="update_btn" type="submit">
                                Update Review
                            </button>
                        </div>
                        
                        {successMessage && (
                            <p className="success-message" style={{ color: 'green', marginTop: '10px' }}>
                                {successMessage}
                            </p>
                        )}
                        {error && (
                            <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>
                                {error}
                            </p>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
}

export default UpdateReviewDetail;